import Vue from "vue";
import Vuex from "vuex";

import account from "./modules/accountModule";
import captcha from "./modules/captchaModule";
import condomAuthorizationModule from "./modules/condomAuthorizationModule";
import condomSolicitationModule from "./modules/condomSolicitationModule";
import dispensation from './modules/dispensation';
import formulaConsolidationModule from "./modules/formulaConsolidationModule";
import formulaRequestModule from "./modules/formulaRequestModule";
import institutionModule from "./modules/institutionModule";
import gelModule from "./modules/lubricantSolicitationModule";
import password from "./modules/passwordModule";
import profileModule from "./modules/profileModule";
import profiles from "./modules/profilesModule";
import reopenDeadlineModule from "./modules/reopenDeadlineModule";
import routes from "./modules/routesModule";
import solicitationFormulaModule from "./modules/solicitationFormulaModule";
import user from "./modules/userModule";
import grids from "./modules/widgets/grids";
import menu from "./modules/widgets/menu";
import modals from "./modules/widgets/modals";
import notifications from "./modules/widgets/notifications";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // WIDGETS
    notifications,
    grids,
    modals,
    menu,

    // MODULES
    routes,
    captcha,
    password,
    account,
    user,
    profiles,
    profileModule,
    institutionModule,
    formulaRequestModule,
    reopenDeadlineModule,
    condomSolicitationModule,
    dispensation,
    formulaConsolidationModule,
    gelModule,
    solicitationFormulaModule,
    condomAuthorizationModule
  },
});
